import { render } from "./NestJSIcon.vue?vue&type=template&id=4fd27282&scoped=true"
import script from "./NestJSIcon.vue?vue&type=script&lang=js"
export * from "./NestJSIcon.vue?vue&type=script&lang=js"

import "./NestJSIcon.vue?vue&type=style&index=0&id=4fd27282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd27282"]])

export default __exports__